import { call, select } from 'redux-saga/effects';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import AnalyticsService from '../../../../services/analytics.service';
import AnalyticsEvents from '../../../../services/analytics.constants';

export default function* deletePaymentSource(id) {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/billing/payment-sources/${id}`;

  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.DELETE,
    body: {},
  });

  if (!error && success) {
    AnalyticsService.track(AnalyticsEvents.PaymentDeleted, { paymentId: id });
  } else {
    console.error(error);
  }
}
